import { type HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

type SkeletonProps = HTMLAttributes<HTMLDivElement>

/**
 * A placeholder component that can be used to indicate content is loading. For
 * placeholders that represent text or paragraphs of text, consider using the
 * SkeletonTextWrapper component.
 *
 * ```tsx
 * import { Skeleton } from "@tokenterminal/ui/progress/skeleton/Skeleton"
 *
 * <Skeleton width="100px" height="100px" />
 * ```
 */

export const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return <div className={twMerge("tt-skeleton", className)} {...props} />
}
